<template>
<div class="creek-seek-bar" v-if="Creek.audio.type=='file' || (audio && audio.type == 'file')">
  <div class="creek-seek-bar-clickable" v-on:mousedown.prevent.stop="onBarMouseDown" v-on:mouseup.prevent.stop="onBarMouseUp" v-on:mousemove.prevent.stop="onBarMouseMove" v-on:mouseleave.prevent="onBarMouseLeave" ref="seekBar"></div>
  <div class="creek-seek-bar-fill" :style="{width: seekBarFillPercent}"></div>
  <div class="creek-seek-bar-position" :style="{left: seekBarFillPercent}"></div>
  <div class="creek-seek-bar-time" v-if="this.Creek.audio.file.positionFormatted && this.Creek.audio.file.durationFormatted" :class="{ 'creek-seek-bar-time-left': seekBarFillDecimal > 0.5, 'creek-seek-bar-time-right': seekBarFillDecimal <= 0.5}" v-text="this.Creek.audio.file.positionFormatted + ' / ' + this.Creek.audio.file.durationFormatted"></div>
</div>
</template>

<style lang="stylus">

.creek-seek-bar
  background rgba(0,0,0,.2);
  position relative
  width 100%
  height 26px
  overflow hidden
  line-height 100%
  &:hover
    cursor pointer

.creek-seek-bar-clickable
  height 100%
  width 100%
  position absolute
  z-index 1
  
.creek-seek-bar-fill
  background rgba(255,255,255,.6);
  position absolute
  height 100%
  left 0
  transition width 0.2s
  padding-right 5px

.creek-seek-bar-position
  background rgba(255,255,255,1);
  position absolute
  height 100%
  top 0
  width 10px
  transition all 0.2s

.creek-seek-bar-time 
  position absolute
  padding 4px 12px
  font-size 14px
  opacity 0.5
  color #fff !important
  
.creek-seek-bar-time-left
  left 0
  opacity 1
  // color #000
  color #fff !important

.creek-seek-bar-time-right 
  right 0
  opacity 1
  color #fff !important


</style>

<script type="text/javascript">
export default {

  name: 'creek-audio-seek-bar',

  props: ['audio'],

  data () {
    return {
        position: null,
        seekDragging: false,
    }
  },

  computed: {

    seekBarFillDecimal() {
      var f = this.Creek.audio.file;
      var decimal = 0.00;
      var decimalRounded = 0.00;
      // if(f.position && typeof p.seek == "function"){
        try {
          decimal = f.position / f.duration;
        }
        catch(e){
          console.log(e);
        }
        decimalRounded = decimal.toFixed(4);
        // decimalRounded = decimal.toFixed(2);
      // }
      return decimalRounded;
    },
    seekBarFillPercent() {
      return (this.seekBarFillDecimal * 100) + "%";
    }

  },

  methods: {

    onBarMouseDown: function(event) {
        this.seekDragging = true
        this.dragSeek(event)
    },

    onBarMouseUp: function(event) {
        this.seekDragging = false
    },

    onBarMouseMove: function(event) {
        if (this.seekDragging){
            this.dragSeek(event)
        }
    },

    onBarMouseLeave: function(event) {
        this.seekDragging = false
    },

    dragSeek: function(event) {
        var posX = event.offsetX;
        var clickWhere = event.pageX - posX;
        // console.log(clickWhere);
        var width = this.$refs.seekBar.clientWidth;
        // console.log(posX);
        // console.log(width);
        this.seekPosition = (this.Creek.audio.file.duration * (posX / width)).toFixed(2);
        // console.log(this.seekPosition + " / " + this.Creek.audio.file.duration);
        this.Creek.audio.file.player.seek(this.seekPosition);
        this.Creek.audio.file.state = "loading";

    }

  }

}

</script>
